import StepFlow from "../components/StepsFlow";
import FormComponent from "../components/Register";
import Final from "../components/Final";
import Header from "../components/Header";
import FakeForm from "../components/FakeForm";

const Register = () => {
  return (
    <>
      <Header></Header>
      <main className="auto-debit-content-wrapper">
        <StepFlow></StepFlow>
        <FormComponent></FormComponent>
        <Final></Final>
        <FakeForm></FakeForm>
      </main>
    </>
  );
};

export default Register;
